import classNames from 'classnames';
import styled from 'styled-components';
import type { MutationCreateCustomerParams } from '$apollo/gql/customer';
import { PersonalDetailsForm } from '$components/pages/checkout/personaldetails/components/PersonalDetailsForm';
import { useAppContext } from '$util/AppContext';
import { getShortTextByKey } from '$cms/getDataByKey';

const Styled = styled(PersonalDetailsForm)`
  display: flex;
  flex-direction: column;
  .Button {
    margin: 40px auto 30px;
    width: 260px;
    display: flex;
    justify-content: center;
  }
`;

export interface RegisterFormProps {
  readonly onSubmit: (values: MutationCreateCustomerParams) => void;
  readonly loading?: boolean;
  readonly className?: string;
}

export function RegisterForm({ onSubmit, loading, className }: RegisterFormProps): JSX.Element {
  const AppContext = useAppContext();
  const {
    cmsContent: { dictionary },
  } = AppContext;

  const getShortText = getShortTextByKey.bind(dictionary);
  const createAccountCta = getShortText('register.button.label', 'Create account');
  return (
    <Styled
      className={classNames('RegisterForm', className)}
      values={{}}
      isGuestUser
      hasPurchaseOrder={false}
      onSubmit={onSubmit}
      showFormHeading={false}
      inFormCta={createAccountCta}
      loading={loading}
    />
  );
}
